import {
  IconHighDemand16,
  IconProductCianLogo12,
  IconProductDocumentsVerified12,
  Label as UIKitLabel,
} from '@cian/ui-kit';
import * as React from 'react';

import { getTextColor } from './utils';
import { EColor, IPhotoLabel } from '../../types';
import { SuperAgentIcon } from '../SuperAgentIcon';

//TODO: Заменить на цвет из кита, когда цвет будет поддерживаться в ките.
const ACCENT_SUCCESS_10 = 'rgba(58, 197, 0, 0.10)';

const BACKGROUND_MAP: Partial<Record<EColor, string>> = {
  orange: 'warning15_100',
  blue: 'primary_10',
  blueOnlyCian: 'primary_10',
  blueGoodPrice: 'primary_10',
  green: ACCENT_SUCCESS_10,
  greenForOwner: ACCENT_SUCCESS_10,
  greenForCheckedOwner: ACCENT_SUCCESS_10,
  white: 'gray10_100',
  grey: 'transparent',
  purpleDiscountMortgage: 'rgba(135,41,255,0.1)',
  greenForSuperAgent: ACCENT_SUCCESS_10,
};

const ICON_MAP: Partial<Record<EColor, React.ReactElement>> = {
  blueOnlyCian: <IconProductCianLogo12 color="primary_100" />,
  greenForCheckedOwner: <IconProductDocumentsVerified12 color="success_100" />,
  purpleDiscountMortgage: <IconHighDemand16 color="purple_label_100" />,
  greenForSuperAgent: <SuperAgentIcon />,
};

export const LabelComponent: React.FC<IPhotoLabel> = ({ color, name }) => {
  return (
    <UIKitLabel background={BACKGROUND_MAP[color]} color={getTextColor(color)} icon={ICON_MAP[color]}>
      {name}
    </UIKitLabel>
  );
};

export const Label = React.memo(LabelComponent);
